import { Outlet } from "react-router-dom";
import { ContextBar } from "./ContextBar";
import { SideRail } from "./SideRail";

/**
 * Shell aus dem Redesign-Bundle: 72px Side-Rail (hover-expand 232px) links,
 * sticky Context-Bar oben mit Breadcrumb + Tenant-Strip. Main-Content fließt
 * dazwischen mit max-width 1400px.
 */
export function AppShell() {
  return (
    <>
      <div className="app-bg" />
      <div className="app">
        <SideRail />
        <div className="main">
          <ContextBar />
          <Outlet />
        </div>
      </div>
    </>
  );
}
